import api from './api';
import type { AuthResponse, LoginRequest, RegisterRequest } from '../types';

// User data only - token is in HttpOnly cookie
const USER_KEY = 'cartcritic_user';

export const authService = {
  async login(credentials: LoginRequest): Promise<AuthResponse> {
    const response = await api.post<AuthResponse>('/auth/login', credentials);
    // Token is set as HttpOnly cookie by backend
    sessionStorage.setItem(USER_KEY, JSON.stringify(response.data.user));
    return response.data;
  },

  async register(data: RegisterRequest): Promise<AuthResponse> {
    const response = await api.post<AuthResponse>('/auth/register', data);
    // Token is set as HttpOnly cookie by backend
    sessionStorage.setItem(USER_KEY, JSON.stringify(response.data.user));
    return response.data;
  },

  async logout() {
    try {
      // Call backend to clear HttpOnly cookie
      await api.post('/auth/logout');
    } catch {
      // Ignore errors
    }
    sessionStorage.removeItem(USER_KEY);
  },

  getStoredUser() {
    const userStr = sessionStorage.getItem(USER_KEY);
    return userStr ? JSON.parse(userStr) : null;
  },

  async verifyEmail(token: string): Promise<void> {
    await api.post('/auth/verify-email', { token });
  },

  async resendVerificationEmail(email: string): Promise<void> {
    await api.post('/auth/resend-verification', { email });
  },

  // Check if user data exists (actual auth is verified by cookie)
  isAuthenticated(): boolean {
    return !!sessionStorage.getItem(USER_KEY);
  },
};
